import { render, staticRenderFns } from "./WatchlistDecisionModal.vue?vue&type=template&id=27b8f3cc&scoped=true"
import script from "./WatchlistDecisionModal.vue?vue&type=script&lang=js"
export * from "./WatchlistDecisionModal.vue?vue&type=script&lang=js"
import style0 from "./WatchlistDecisionModal.vue?vue&type=style&index=0&id=27b8f3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8f3cc",
  null
  
)

export default component.exports